"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckOpenAccount = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsFinancial_1 = require("../../model/hsFinancial");
var service_1 = require("../../../library/base/service");
var CheckOpenAccount = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(CheckOpenAccount, _super);
    function CheckOpenAccount() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '判断交易所是否开户接口';
        _this.code = '105039';
        _this.desc = '判断交易所是否开户接口';
        _this.requestParams = new hsFinancial_1.CheckOpenAccountRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return CheckOpenAccount;
}(service_1.BaseService));
exports.CheckOpenAccount = CheckOpenAccount;
//# sourceMappingURL=checkOpenAccount.js.map